
import { Skeleton } from "antd";

export default function IngredientInputSkeleton() {
  return (
    <section className="w-full">
      <div className="flex items-center space-x-3">
        <div className="w-[300px] ingredient-skeleton">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
        <div className="w-[130px] ingredient-skeleton ingredient-item-unit-skeleton">
          <Skeleton.Input active={true} size={"default"} block={true} />
        </div>
        <div className="w-[300px] ingredient-skeleton">
          <Skeleton.Input active={true} size={"square"} block={true} />
        </div>
      </div>
    </section>
  );
}
